import React, { useCallback } from 'react';
import { Alert } from './Alert.js';
import { useToast } from './hooks/useToast.js';

const Toaster = ({ toasts }) => {
    const { removeToast } = useToast();
    const onClear = useCallback((id) => {
        removeToast(id);
    }, [removeToast]);
    return (React.createElement("div", { className: "fixed z-40 w-full max-w-sm max-h-full bottom-0 sm:top-0 sm:bottom-auto left-0 right-0 mx-auto p-4 grid gap-3 pointer-events-none" }, toasts.map(({ animate = true, id, content, onClose = () => null, ...rest }) => (React.createElement(Alert, { animate: true, ...{
            ...rest,
            animate,
            key: id,
            id,
            onClose: id => {
                onClose(id);
                onClear(id);
            },
        } }, content)))));
};

export { Toaster };
//# sourceMappingURL=Toaster.js.map
